import script from "./AiCard.vue?vue&type=script&lang=ts&setup=true"
export * from "./AiCard.vue?vue&type=script&lang=ts&setup=true"

import "./AiCard.scss?vue&type=style&index=0&lang=scss&external"

const __exports__ = script;

export default __exports__